<fieldset class="grid" aria-label="Einstellungen zu Zertifikat / Schiffsbrief" data-test-id="aufgabe-zertifikat-root">
	<div class="row">
		<div class="column">
			<mat-radio-group
				color="primary"
				aria-label="Bitte Aktion wählen"
				class="column"
				[formControl]="bodyControls.taetigkeit"
				(change)="toggleTaetigkeitAndSendenControls($event.value)"
				data-test-id="aufgabe-zertifikat-taetigkeit">
				<mat-radio-button
					class="focus-inwards-dark"
					[value]="taetigkeiten.NOTIZ"
					data-test-id="notiz-radio-button">
					gem. Notiz
				</mat-radio-button>
				<mat-radio-button
					class="focus-inwards-dark"
					[value]="taetigkeiten.FERTIGEN"
					data-test-id="fertigen-radio-button">
					fertigen
				</mat-radio-button>
				<mat-radio-button
					class="focus-inwards-dark"
					[value]="taetigkeiten.BERICHTIGEN"
					data-test-id="berichtigen-radio-button">
					berichtigen
				</mat-radio-button>
				<mat-radio-button
					class="focus-inwards-dark"
					[value]="taetigkeiten.NACH_EINGANG_BERICHTIGEN"
					data-test-id="nach-eingang-berichtigen-radio-button">
					nach Eingang berichtigen
				</mat-radio-button>
				<mat-radio-button
					class="focus-inwards-dark"
					[value]="taetigkeiten.VORHANDEN"
					data-test-id="vorhanden-radio-button">
					vorhanden
				</mat-radio-button>
			</mat-radio-group>
			@if (bodyControls.versandTaetigkeit.enabled) {
				<mat-radio-group
					aria-label="Bitte Versandaktion wählen"
					class="column indented"
					[formControl]="bodyControls.versandTaetigkeit"
					data-test-id="aufgabe-zertifikat-versandtaetigkeit">
					<mat-radio-button
						color="primary"
						class="focus-inwards-dark"
						[value]="versandTaetigkeit.SENDEN_AN"
						data-test-id="senden-an-radio-button">
						senden an
					</mat-radio-button>
					<mat-radio-button
						color="primary"
						class="focus-inwards-dark"
						[value]="versandTaetigkeit.AUSHAENDIGEN_AN"
						data-test-id="aushaendigen-an-radio-button">
						aushändigen an
					</mat-radio-button>
				</mat-radio-group>
			}
		</div>
		@if (bodyControls.sendenAn.enabled) {
			<schir-int-client-kontakt-kategorie-checkboxes
				class="column"
				[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer()"
				[control]="bodyControls.sendenAn"
				data-test-id="kontakt-kategorie-checkbox-root" />
		}
	</div>
	<schir-int-client-notiz-in-aufgabe-editor
		class="row note"
		[aufgabenTyp]="aufgabenTyp()"
		data-test-id="aufgabe-zertifikat-notiz" />
</fieldset>
